// Raw zone codes from astar's GIS data (risk_type, peril, regime, status) → readable labels.
const SPECIAL = { war_terrorism: "War & terrorism", imo: "IMO" }

export function zoneValueLabel(value) {
  if (value == null || value === "") return null
  const raw = String(value)
  if (Object.hasOwn(SPECIAL, raw)) return SPECIAL[raw]
  const text = raw.replace(/_/g, " ")
  return text.charAt(0).toUpperCase() + text.slice(1)
}
